/** Share lazy imports with navigation so hovering or focusing a link warms its code. */
export const pageLoaders = {
  '/': () => import('@/pages/Overview'),
  '/calls': () => import('@/pages/Calls'),
  '/contacts': () => import('@/pages/Contacts'),
  '/reports': () => import('@/pages/Reports'),
  '/team': () => import('@/pages/Team'),
  '/exclusions': () => import('@/pages/Exclusions'),
  '/ai': () => import('@/pages/AiAnalysis'),
  '/webhooks': () => import('@/pages/Webhooks'),
  '/api-apps': () => import('@/pages/ApiApps'),
  '/recordings': () => import('@/pages/Recordings'),
  '/billing': () => import('@/pages/Billing'),
  '/account': () => import('@/pages/Account'),
  '/help': () => import('@/pages/Help'),
  '/welcome': () => import('@/pages/Welcome'),
};

export function preloadPage(href: string) {
  const load = pageLoaders[href.split('?')[0] as keyof typeof pageLoaders];
  if (load)
    void load().catch(() => {
      /* Route navigation retains its own error boundary. */
    });
}
